import { atom } from 'recoil'


export default atom({
  key: 'mapDampingData',
  default: { latitude: 0, longitude: 0, innerRadius: 2000, outerRadius: 3000 }
})
